"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLocalUrl = exports.getManifestEntryPoint = exports.MANIFEST_FILE_NAME = exports.APPS_DIRECTORY = void 0;
const tslib_1 = require("tslib");
const adtech_common_1 = require("@wetransfer/adtech-common");
const axios_1 = require("axios");
exports.APPS_DIRECTORY = 'apps';
exports.MANIFEST_FILE_NAME = 'asset-manifest.json';
// This function returns the entry point of the application from the manifest file
// it uses a cache-bust technique to avoid browser cache
const getManifestEntryPoint = (manifestUrl) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const payload = yield (0, adtech_common_1.request)({
        path: `${manifestUrl}?cache-bust=${Math.random()}`,
    });
    const manifest = payload.body;
    const { entrypoints } = manifest;
    const [main] = entrypoints;
    return main;
});
exports.getManifestEntryPoint = getManifestEntryPoint;
// TODO: verify if is this necessary
const createLocalUrl = (url) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const result = yield axios_1.default.get(url, { responseType: 'blob' });
    const localUrl = URL.createObjectURL(result.data);
    return { localUrl, cleanup: () => URL.revokeObjectURL(localUrl) };
});
exports.createLocalUrl = createLocalUrl;
//# sourceMappingURL=get-manifest-entry-point.js.map